/* esm.sh - space-separated-tokens@2.0.2 */
function r(t){let n=String(t||"").trim();return n?n.split(/[ \t\n\r\f]+/g):[]}function i(t){return t.join(" ").trim()}export{r as parse,i as stringify};
//# sourceMappingURL=space-separated-tokens.mjs.map